import { FC } from 'react';

type Props = {
	className?: string;
};

const AlertIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.7216 2.20683C9.55234 1.93106 10.4477 1.93106 11.2784 2.20683C12.1058 2.48145 12.7554 3.13279 13.408 4.04794C14.0584 4.96005 14.7772 6.23181 15.7036 7.87116L15.74 7.93552C16.6666 9.5751 17.3853 10.8468 17.8332 11.8781C18.2833 12.9145 18.5074 13.8092 18.3286 14.6688C18.1485 15.5344 17.7045 16.3214 17.0577 16.9163C16.4126 17.5097 15.5342 17.7601 14.4282 17.8803C13.3284 17.9998 11.8897 17.9998 10.0381 17.9998H9.96201C8.11034 17.9998 6.6717 17.9998 5.57191 17.8803C4.46585 17.7601 3.58744 17.5097 2.94231 16.9163C2.29561 16.3214 1.85156 15.5344 1.67148 14.6688C1.49264 13.8092 1.71679 12.9145 2.16685 11.8781C2.61475 10.8468 3.33344 9.5751 4.26005 7.93551L4.29642 7.87116C5.22287 6.23181 5.94159 4.96005 6.59203 4.04794C7.24464 3.13279 7.89424 2.48145 8.7216 2.20683ZM9.75175 9.24074C9.94453 9.26666 10.2113 9.33604 10.4376 9.56238C10.664 9.78872 10.7334 10.0554 10.7593 10.2483C10.7807 10.408 10.7806 10.5937 10.7805 10.7496V10.7804V13.9023C10.7805 14.3334 10.4311 14.6828 10 14.6828C9.56896 14.6828 9.21954 14.3334 9.21954 13.9023V10.7804C8.78848 10.7804 8.43906 10.431 8.43906 9.99992C8.43906 9.56886 8.78848 9.21944 9.21954 9.21944H9.25029C9.40631 9.21936 9.59199 9.2192 9.75175 9.24074ZM9.99643 6.09752C9.56732 6.09752 9.21946 6.44695 9.21946 6.878C9.21946 7.30904 9.56732 7.65848 9.99643 7.65848H10.0035C10.4326 7.65848 10.7804 7.30904 10.7804 6.878C10.7804 6.44695 10.4326 6.09752 10.0035 6.09752H9.99643Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default AlertIconSolid;
